// extracted by mini-css-extract-plugin
module.exports = {"signIn":"googleAuth_signIn__3_48t","profileContainer":"googleAuth_profileContainer__1zJU5","profileIcon":"googleAuth_profileIcon__3woct"};